import React, { useState, useEffect } from 'react';
import { Typography, Steps, Radio, Row, Col, Upload, Button, Modal, Badge, Popover } from 'antd';
import { commonNotifications } from 'mortgage-documents/src/document-boxes/CommonItems';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { useTranslation } from 'react-i18next';
import { refreshData } from '../../../store/auth/actions';
import { CheckOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { showPay } from '../../../store/data/actions';
import { useDispatch } from 'react-redux';
import CheckOutComponent from '../../Operaciones/CheckOutComponent';
import DocumentationNew from '../MortagageAplication/DocumetationNew/DocumentationNew';
import leftArrowIcon from '../../../assets/icons/leftArrowIcon.svg';
import moment from 'moment';
const moreHorizontal = require('../../../assets/icons/moreHorizontal.png');
const trash = require('../../../assets/icons/trash.png');

const { Text } = Typography;
const { Step } = Steps;

const AppraisalMobile = ({ dataMortgage, operationId }) => {
	const [existAppraisal, setExistAppraisal] = useState(false);
	const [valuesData, setValuesData] = useState([]);
	const userToken = useSelector((state) => state.auth.token);
	const [valueRadio, setValueRadio] = useState(undefined);
	const [mortgageData, setMortgageData] = useState();
	const [isClientPay, setIsClientPay] = useState(false);
	const { t } = useTranslation();
	const [, setCheckBoxData] = useState(
		dataMortgage !== undefined &&
			dataMortgage.mortgage &&
			dataMortgage.mortgage.signedDocumentation === true
			? true
			: false
	);
	const [bankOffer, setBankOffer] = useState();
	const [saveFileDataField, setSaveFileDataField] = useState(null);
	const [typeFile, setTypeFile] = useState();
	const [showModalDelete, setShowModalDelete] = useState(false);
	const [appraisal, setAppraisal] = useState(undefined);
	const dispatch = useDispatch();
	const showPayBoolean = useSelector((state) => state.data.showPay);

	const [dataClient, setDataClient] = useState('');
	const [pageNumber, setPageNumber] = useState(2);
	const [mortgageOperation, setMortgageOperation] = useState(undefined);
	const [hidden, setHidden] = useState(false);

	useEffect(() => {
		if (operationId) {
			getAppraisal();
			//setValueRadio("own");
			getMortgageData();
			getClientPay();
			getBankOffer();
			getTokenPay();
		}
	}, []);

	useEffect(() => {
		getClientPay();
	}, [showPayBoolean]);

	useEffect(() => {
		setExistAppraisal(valuesData.some((value) => value.type === 'appraisal'));
	}, [valuesData]);

	const getTokenPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/appraisal/checkout`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setDataClient(response.data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const getMortgageData = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/data/get/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setMortgageOperation(response.data.data.operation);
				setMortgageData(response.data.data.mortgage);
				if (response.data.data.mortgage.reportAppraisal !== undefined) {
					setValueRadio(response.data.data.mortgage.reportAppraisal);
				}
			});
	};
	const getBankOffer = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/selected-bank-offer/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setBankOffer(response.data.data.selectedOffer);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getClientPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/operation/status`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setIsClientPay(response.data.data.completed);
			});
	};

	const getAppraisal = () => {
		axios
			.get(`${env.api.url}/v1/documents/get-operation-documents/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setValuesData(response.data.data);
				setExistAppraisal(response.data.data.some((value) => value.type === 'appraisal'));
				setAppraisal(response.data.data.find((value) => value.type === 'appraisal'));
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleUploadFile = (file) => {
		axios
			.put(
				`${env.api.url}/api/mortgages/attachment`,
				{
					mortgageId: operationId,
					file: file[1].file,
					fileName: file[1].fileName,
					type: typeFile,
					owner: 'owner1'
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then(() => {
				commonNotifications('success', t('document.success'), t('document.analyst'), true);
				getAppraisal();
			})
			.catch((error) => {
				commonNotifications('error', t('document.waitUploadError'), t('document.error'), true);
				console.log(error);
			});
	};

	const saveFileData = (file, name) => {
		const documentFile = [saveFileDataField];
		documentFile.push({
			file,
			fileName: name
		});
		setSaveFileDataField(documentFile);
		handleUploadFile(documentFile);
	};
	const uploadProps = {
		beforeUpload: (file) => {
			return new Promise(() => {
				const reader = new FileReader();
				reader.readAsDataURL(file);

				if (file.size < 50000000) {
					reader.onload = () => {
						const base64File = reader.result.split(',')[1];
						saveFileData(base64File, file.name);
					};
				} else {
					commonNotifications(
						'error',
						t('document.waitUploadError'),
						t('documentation.tooHeavy'),
						true
					);
				}
			});
		}
	};
	const handleClickPlus = (typeFile) => {
		setTypeFile(typeFile);
	};

	const deleteDocument = () => {
		if (!_.isNil(appraisal.page)) {
			commonNotifications('error', t('error.deleteFileEv'), t('error.deleteFileEv2'), true);
		} else {
			axios
				.get(`${env.api.url}/v1/documents/delete-document/${appraisal.id}`, {
					headers: { Authorization: `Bearer ${userToken}` }
				})
				.then(() => {
					setShowModalDelete(false);
					getAppraisal();
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};

	const downloadApprasal = () => {
		axios
			.get(`${env.api.url}/v1/documents/get-document-url/${appraisal.id}?token=${userToken}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					window.location.href = response.data.data.url;
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const modalDelete = (documentId) => {
		deleteDocument(documentId);
	};

	const selectWidget = (
		<div>
			<div
				onClick={() => downloadApprasal()}
				style={{
					display: 'flex',
					border: 'none',
					padding: 5,
					cursor: 'pointer'
				}}>
				<EyeOutlined className="see-document" style={{ marginTop: 3 }} />
				<Text className="see-document see-document-text" style={{ marginLeft: 4 }}>
					{t('doc.seeNew')}
				</Text>
			</div>
			<div
				onClick={() => modalDelete(appraisal.id)}
				style={{
					display: 'flex',
					border: 'none',
					padding: 5,
					cursor: 'pointer',
					alignItems: 'center'
				}}>
				<img src={trash} alt="trash" width={17} height={'auto'} style={{ marginLeft: -2 }} />
				<Text className="delete-document delete-document-text" style={{ marginLeft: 4 }}>
					{t('loan.delete')}
				</Text>
			</div>
		</div>
	);

	const saveDataOnClick = (participant, key, value) => {
		let valueRadio = {
			key: 'operation',
			subkey: 'firstClickToAppraisal',
			value: moment().format('YYYY-MM-DD')
		};

		if (
			mortgageData.reportAppraisal !== undefined &&
			mortgageOperation.firstClickToAppraisal !== undefined
		) {
			valueRadio = {
				key: 'operation',
				subkey: 'ultimateClickToAppraisal',
				value: moment().format('YYYY-MM-DD')
			};
		}

		axios
			.post(
				`${env.api.url}/v1/mortgages/data/multiple/update/${operationId}`,
				{
					values: [
						{
							key: participant,
							subkey: key,
							value: value
						},
						{
							key: valueRadio.key,
							subkey: valueRadio.subkey,
							value: valueRadio.value
						}
					]
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				getMortgageData();
				refreshData();
				setCheckBoxData(response.data.data.mortgage.signedDocumentation);
			});
	};

	const renderSelect = () => {
		return (
			<div style={{ marginTop: 8, lineHeight: '16px' }}>
				{_.isNil(mortgageData?.appraiser) && (
					<Text style={{ color: '#666666', fontSize: 12, fontWeight: 400 }}>
						{t('appraisal.selectOptions')}:
					</Text>
				)}

				{!isClientPay && (
					<Row style={{ marginTop: 8, display: 'flex', width: '100%' }}>
						<Col span={24} style={{ textAlign: 'left', width: '100%' }}>
							<Radio
								value={'own'}
								checked={mortgageData && mortgageData.reportAppraisal === 'own' ? true : false}
								onChange={(e) => {
									saveDataOnClick('mortgage', 'reportAppraisal', e.target.value);
									setValueRadio(e.target.value);
								}}>
								{' '}
								<Text style={{ color: '#666666', fontSize: 12, fontWeight: 400 }}>
									{t('appraisal.miAppraisal')}
								</Text>
							</Radio>
						</Col>
					</Row>
				)}
				{valueRadio !== 'h1' &&
					!_.isNil(valueRadio) &&
					existAppraisal === false &&
					mortgageData &&
					mortgageData.reportAppraisal !== 'bank' && (
						<div style={{ marginTop: 8 }}>
							<Upload {...uploadProps}>
								<Button
									onClick={() => handleClickPlus('appraisal')}
									style={{
										padding: '8px 16px',
										backgroundColor: 'white',
										borderRadius: '4px',
										border: '1px solid #BE4B0A',
										height: 60
									}}>
									<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
										<Badge dot={true} size="small" className="gb-badget" style={{ marginTop: 8 }} />
										<Text>{t('appraisal.infoAppraisal')}</Text>
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: 4,
											marginTop: 8
										}}>
										<Text style={{ fontSize: 16, color: '#C80000' }}>{'+'}</Text>
										<Text className="attach-document-text">{t('file.newOnboardingDocs')}</Text>
									</div>
								</Button>
							</Upload>
						</div>
					)}
				{existAppraisal && appraisal && appraisal.type === 'appraisal' && (
					<div style={{ marginTop: 8, display: 'flex' }}>
						<Button
							className="appraisal-button"
							style={{
								padding: '8px 16px',
								backgroundColor: 'white',
								borderRadius: '4px',
								height: 60,
								borderColor: !_.isNil(appraisal.page) ? '#477306' : undefined,
								cursor: 'default'
							}}>
							<Text
								style={{
									color: '#666666',
									fontSize: 12,
									fontWeight: 400
								}}>
								{!_.isNil(appraisal.page) && (
									<CheckOutlined
										style={{
											color: '#477306',
											marginRight: 4
										}}
									/>
								)}
								{t('appraisal.infoAppraisal')}
							</Text>
							<div style={{ fontSize: 10, fontWeight: 400, color: '#808080', marginTop: 8 }}>
								{t('__sabadell-es__appraisal.appraisal') + '.pdf'}
								<Popover
									content={selectWidget}
									style={{ textAlign: 'center' }}
									placement="bottom"
									trigger="hover"
									open={hidden}
									onOpenChange={() => setHidden(!hidden)}>
									<img src={moreHorizontal} style={{ marginLeft: 24, cursor: 'pointer' }} />
								</Popover>
							</div>
						</Button>
					</div>
				)}

				{isClientPay === false && (
					<Col span={24} style={{ paddingLeft: 0, marginTop: 8 }}>
						<Radio
							value={'h1'}
							checked={mortgageData && mortgageData.reportAppraisal === 'h1' ? true : false}
							onChange={(e) => {
								saveDataOnClick('mortgage', 'reportAppraisal', e.target.value);
								setValueRadio(e.target.value);
							}}>
							<div style={{ lineHeight: '16px' }}>
								<Text style={{ color: '#666666', fontSize: 12, fontWeight: 400 }}>
									{t('appraisal.ev')}
								</Text>
							</div>
						</Radio>
					</Col>
				)}

				{!existAppraisal && (
					<Row style={{ marginTop: 8, marginLeft: 20 }}>
						{valueRadio === 'h1' && !_.isNil(mortgageData?.appraiser) && (
							<Text style={{ fontSize: 12, fontWeight: 400, color: '#666666' }}>
								{isClientPay === false
									? t('appraisal.availableAppraisal')
									: t('m_appraisal.paymentDone')}
							</Text>
						)}
						{valueRadio === 'h1' && _.isNil(mortgageData?.appraiser) && (
							<>
								<Text style={{ fontSize: 12, fontWeight: 400, color: '#666666' }}>
									{t('appraisal.infoEV')}
								</Text>
							</>
						)}
						{valueRadio === 'h1' && (
							<div style={{ display: 'flex', flexDirection: 'column', marginTop: 8, gap: 8 }}>
								<div>
									<Text style={{ fontSize: 12, fontWeight: 300, color: '#666666' }}>
										{t('appraisal.appraiser')}
									</Text>{' '}
									<Text
										style={{
											fontSize: 12,
											fontWeight: 600,
											color: mortgageData?.appraiser ? '#262626' : '#666666'
										}}>
										{mortgageData?.appraiser ? mortgageData?.appraiser : t('appraisal.confirm')}
									</Text>
								</div>
								<div>
									<Text style={{ fontSize: 12, fontWeight: 300, color: '#666666' }}>
										{t('appraisal.price')}
									</Text>{' '}
									<Text
										style={{
											fontSize: 12,
											fontWeight: 600,
											color: mortgageData?.appraisalAmount ? '#262626' : '#666666'
										}}>
										{mortgageData?.appraisalAmount
											? mortgageData?.appraisalAmount + '€'
											: t('appraisal.confirm')}{' '}
										{isClientPay && '(' + t('operationStatus.finishPay').toLowerCase() + ')'}
									</Text>
								</div>
								{valueRadio === 'h1' && (
									<Button
										id="gb-mortgage-buy-situation-mobile"
										className="button-pay"
										type="primary"
										disabled={_.isNil(mortgageData?.appraisalAmount) || isClientPay}
										onClick={() => payOk()}
										style={{
											fontSize: 16,
											width: '100%',
											height: 40,
											fontWeight: 400
										}}
										htmlType="submit">
										{!isClientPay ? t('appraisal.pay') : t('operationStatus.finishPay')}
									</Button>
								)}
							</div>
						)}
					</Row>
				)}
			</div>
		);
	};

	const renderDescOption2 = () => {
		if (appraisal && mortgageData?.reportAppraisal !== 'h1') {
			if (!_.isNil(appraisal.page)) {
				return (
					<Text
						style={{
							fontSize: 12,
							fontWeight: 400,
							color: '#666666'
						}}>
						{t('m_appraisal.ownPendingDescription')}
					</Text>
				);
			} else {
				return undefined;
			}
		} else {
			if (appraisal && mortgageData?.reportAppraisal === 'h1') {
				return (
					<Text
						style={{
							fontSize: 14,
							fontWeight: 400,
							color: '#666666'
						}}>
						{t('appraisal.availableFile')}
					</Text>
				);
			}
		}
	};

	const payOk = () => {
		dispatch(showPay(true));
	};

	return (
		<div style={{ padding: showPayBoolean ? undefined : 16, paddingLeft: 0 }}>
			{pageNumber == 1 && (
				<div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							marginTop: 16
						}}>
						<div style={{ marginRight: 16, cursor: 'pointer' }} onClick={() => setPageNumber(2)}>
							<img src={leftArrowIcon} alt="leftArrowIcon" height={14} />
						</div>
						<Text style={{ fontSize: 16, fontWeight: 600, color: '#262626' }}>
							{t('document.filePendding')}
						</Text>
					</div>

					<DocumentationNew userMortgageId={operationId} stage={'appraisal'} />
				</div>
			)}
			{!showPayBoolean && pageNumber === 2 && (
				<div>
					<Steps
						direction="vertical"
						size="small"
						status="error"
						current={appraisal && !_.isNil(appraisal.page) ? 1 : 0}
						className="StepsMobileAppraisal">
						<Step
							style={{ color: '#b3b3b3' }}
							title={
								<div style={{ marginTop: 4 }}>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 600,
											color: '#262626'
										}}>
										{t('appraisal.infoAppraisal')}
									</Text>
								</div>
							}
							description={renderSelect()}></Step>
						<Step
							title={
								<div style={{ lineHeight: '16px', marginTop: 4 }}>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 600,
											color: appraisal && !_.isNil(appraisal.page) ? '#262626' : '#E5E5E5'
										}}>
										{t('appraisal.bank')}
									</Text>
								</div>
							}
							description={renderDescOption2()}></Step>
					</Steps>
				</div>
			)}

			{showPayBoolean && dataMortgage && (
				<CheckOutComponent
					amount={dataMortgage?.mortgage?.appraisalAmount}
					showPayBoolean={showPayBoolean}
					mortgageId={operationId}
					clientSecretToken={dataClient?.paymentSeat?.session?.client_secret}
					dataClient={dataClient}
				/>
			)}
			<Modal
				className="modal-documents-movile"
				width={328}
				open={showModalDelete}
				closable={true}
				onCancel={() => {
					setShowModalDelete(false);
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { width: '48%' }
				}}
				cancelButtonProps={{
					className: 'button-secundary-gibobs',
					style: { width: '48%' }
				}}
				onOk={() => deleteDocument()}>
				<div style={{ display: 'flex', flexDirection: 'column', marginTop: 16 }}>
					<Text style={{ fontWeight: 600, color: '#262626', fontSize: 16 }}>
						{t('delete.fileAppraisal')}
					</Text>
				</div>
				<div style={{ marginTop: 24 }}>
					<Text style={{ fontWeight: 400, color: '#262626', fontSize: 14 }}>
						{t('delete.fileAppraisal2')}
					</Text>
				</div>
			</Modal>
		</div>
	);
};

export default AppraisalMobile;
